import React from "react";
import { css } from "emotion";
import NextButton from "./NextButton";
import typeList from "./data/typeList";
import TypeItem from "./TypeItem";
import { colors } from "../../styles/theme";

const SelectTypeList = () => {
  return (
    <div className={container}>
      {typeList.map((item) => (
        <TypeItem key={item.title} item={item} />
      ))}
    </div>
  );
};

export default SelectTypeList;

const container = css`
  align-self: flex-start;
  margin-top: 0 !important;
`;
